import React from 'react'

const AuthLayout = ({children}) => {
  return (
  <div className="flex flex-col md:flex-row h-screen w-screen">
  <div className="w-full md:w-[60vw] px-6 sm:px-12 pt-8 pb-12 flex flex-col">
    <div className="text-3xl sm:text-4xl font-bold text-blue-500 mb-8 sm:mb-16 flex justify-center md:justify-start">
      <img
        src={require("../../assets/image/FWFichier 1@2x.png")}
        alt="Logo"
        className="w-36 sm:w-48"
      />
    </div>
    {children}
  </div>
  <div className="hidden md:flex md:w-[40vw] lg:w-[40vw] h-screen">
    <img
      src={require("../../assets/image/Auth.jpeg")}
      alt="Auth Illustration"
      className="w-full h-full object-cover"
    />
  </div>
</div>


  )
}

export default AuthLayout;